// extracted by mini-css-extract-plugin
export default {"notfound":"NotFoundPage_notfound__0+RxW","iconVector":"NotFoundPage_iconVector__YtKVM","badReq":"NotFoundPage_badReq__zcYIy","text":"NotFoundPage_text__OhoXe"};